// A Liga da Semana no jogo: LIGA_DA_SEMANA de @truco6/planos. Com ela desligada, somem o JOGAR NA LIGA, a busca de
// mesa, a tela da liga e o patrocinador; ranking, pontos, PD e divisões seguem. No modo local, o e2e da liga liga a
// chave por este aparelho (truco6:liga-no-ar), e a mesa local também (LIGA_DA_SEMANA_LOCAL).
import { LIGA_DA_SEMANA } from '@truco6/planos';
import { config } from './config.ts';

export const CHAVE_LIGA_LOCAL = 'truco6:liga-no-ar';

export function ligaNoAr(): boolean {
  if (LIGA_DA_SEMANA) return true;
  if (!config.authLocal) return false;
  try { return localStorage.getItem(CHAVE_LIGA_LOCAL) === '1'; } catch { return false; }
}
